const MAX_SIDE = 512;

export async function processPortrait(
  file: File,
): Promise<{ original: string; processed: string }> {
  if (!file.type.startsWith("image/"))
    throw new Error("Можно выбрать только изображение.");
  const source = await fileToDataUrl(file);
  const image = await loadImage(source);
  const scale = Math.min(
    1,
    MAX_SIDE / Math.max(image.naturalWidth, image.naturalHeight),
  );
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) throw new Error("Обработка изображения недоступна.");
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  const original = canvas.toDataURL("image/jpeg", 0.82);
  const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
  for (let index = 0; index < pixels.data.length; index += 4) {
    const luminance =
      pixels.data[index] * 0.299 +
      pixels.data[index + 1] * 0.587 +
      pixels.data[index + 2] * 0.114;
    pixels.data[index] = Math.round(luminance * 0.04);
    pixels.data[index + 1] = Math.round(luminance * 0.95);
    pixels.data[index + 2] = Math.round(luminance * 0.22);
  }
  context.putImageData(pixels, 0, 0);
  return { original, processed: canvas.toDataURL("image/jpeg", 0.82) };
}

function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () =>
      reject(new Error("Не удалось прочитать изображение."));
    reader.onload = () => resolve(String(reader.result));
    reader.readAsDataURL(file);
  });
}

function loadImage(source: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () =>
      reject(new Error("Не удалось обработать изображение."));
    image.src = source;
  });
}
